// Vuetify 0 — headless primitives (no Material Design styling)
// Styling is handled via CSS design tokens in assets/css/design-tokens.css

export default defineNuxtPlugin(() => {
  // @vuetify/v0 composables are imported directly where needed
  // No global plugin registration required — it's tree-shakeable
});
